import { UiTypography } from '@/components/ui/Typography';

import styles from './Header.module.scss';

export const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.avatar}>
          <img src="../assets/avatar-icon-online.png" alt="avatar-icon" />
        </div>
        <div>
          <UiTypography variant="title-medium" color="white-static">
            Hot girlfriend ❤️💦
          </UiTypography>
          <UiTypography variant="body-small" color="neutral-white">
            Online
          </UiTypography>
        </div>
      </div>
    </header>
  );
};
